var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditGolive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 17.416H2.375C2.05042 17.416 1.78125 17.1468 1.78125 16.8223C1.78125 16.4977 2.05042 16.2285 2.375 16.2285H16.625C16.9496 16.2285 17.2188 16.4977 17.2188 16.8223C17.2188 17.1468 16.9496 17.416 16.625 17.416Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0572 2.75466C13.5214 1.21882 12.0172 1.17924 10.4418 2.75466L9.48388 3.71257C9.40471 3.79174 9.37305 3.91841 9.40471 4.02924C10.0064 6.12716 11.6847 7.80549 13.7826 8.40716C13.8143 8.41507 13.846 8.42299 13.8776 8.42299C13.9647 8.42299 14.0439 8.39132 14.1072 8.32799L15.0572 7.37007C15.841 6.59424 16.221 5.84216 16.221 5.08216C16.2289 4.29841 15.8489 3.53841 15.0572 2.75466Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3576 9.1274C12.128 9.01656 11.9063 8.90573 11.6926 8.77906C11.5184 8.67615 11.3522 8.56531 11.1859 8.44656C11.0513 8.35948 10.893 8.23281 10.7426 8.10615C10.7268 8.09823 10.6713 8.05073 10.608 7.9874C10.3468 7.76573 10.0538 7.48073 9.7926 7.16406C9.76885 7.14823 9.72927 7.09281 9.67385 7.02156C9.59468 6.92656 9.4601 6.76823 9.34135 6.58615C9.24635 6.4674 9.13552 6.29323 9.0326 6.11906C8.90593 5.90531 8.7951 5.69156 8.68427 5.4699C8.53895 5.1585 8.13025 5.066 7.88726 5.30898L3.43552 9.76073C3.3326 9.86365 3.2376 10.0616 3.21385 10.1961L2.78635 13.2282C2.70718 13.7666 2.8576 14.2732 3.1901 14.6136C3.4751 14.8907 3.87093 15.0411 4.29843 15.0411C4.39343 15.0411 4.48843 15.0332 4.58343 15.0174L7.62343 14.5899C7.76593 14.5661 7.96385 14.4711 8.05885 14.3682L12.5179 9.90914C12.7561 9.67101 12.6666 9.26129 12.3576 9.1274Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGolive);
export default __webpack_public_path__ + "static/media/edit-golive.694eba246f8c310784ccb40d26369d68.svg";
export { ForwardRef as ReactComponent };